import {colors} from '@purpose/ui/styles/theme/colors';

export enum USER_ROLES {
  member = 'user',
  merchant = 'merchant',
  organisation = 'organisation'
}

export enum INPUT_ERROR_MESSAGES {
  email = 'General.InputErrorMessages.email',
  password = 'SignUpPage.PersonalDataInputStep.passwordHint',
  website = 'General.InputErrorMessages.website',
  phone = 'General.InputErrorMessages.phone',
  required = 'General.InputErrorMessages.required',
  iban = 'General.InputErrorMessages.iban'
}

export const WEBSHOP_COLORS = {
  black: {
    header: colors.primary.base,
    main: colors.primary[80],
    text: colors.primary.base,
    category: colors.primary.base,
    subscribeButton: colors.primary.base,
    subscribeButtonBorder: colors.primary.base
  },
  grey: {
    header: colors.grey[90],
    main: colors.grey[80],
    text: colors.grey[90],
    category: colors.grey[70],
    subscribeButton: colors.grey[60],
    subscribeButtonBorder: colors.grey[80]
  },
  blue: {
    header: colors.blue[90],
    main: colors.blue[70],
    text: colors.blue[70],
    category: colors.blue[80],
    subscribeButton: colors.blue[60],
    subscribeButtonBorder: colors.blue[80]
  },
  green: {
    header: colors.green[90],
    main: colors.green[80],
    text: colors.green[60],
    category: colors.green[70],
    subscribeButton: colors.green[60],
    subscribeButtonBorder: colors.green[80]
  },
  red: {
    header: colors.red[90],
    main: colors.red[80],
    text: colors.red[60],
    category: colors.red[70],
    subscribeButton: colors.red[60],
    subscribeButtonBorder: colors.red[80]
  },
  yellow: {
    header: colors.orange[100],
    main: colors.orange[90],
    text: colors.orange[60],
    category: colors.orange[90],
    subscribeButton: colors.orange[60],
    subscribeButtonBorder: colors.orange[80]
  },
  default: {
    header: null,
    main: null,
    text: null,
    category: null,
    subscribeButton: null,
    subscribeButtonBorder: null
  }
};

export enum WebshopDesignEnum {
  banner_text = 'banner_text',
  banner = 'banner',
  text = 'text'
}

export const COOKIES_FIELDS = {
  token: 'jwtAuthenticationToken',
  refreshToken: 'refreshAuthenticationToken'
};

export const PAGENAMES_TITLE_IDS = {
  feed: 'PageNames.feed',
  about: 'PageNames.about',
  terms: 'PageNames.terms',
  privacyPolicy: 'PageNames.privacyPolicy',
  benefits: 'PageNames.benefits',
  subscriptions: 'PageNames.subscriptions',
  notifications: 'PageNames.notifications',
  settings: 'PageNames.settings',
  cashback: 'PageNames.cashback',
  home: 'PageNames.home',
  save: 'PageNames.save',
  membership: 'PageNames.membership',
  activity: 'PageNames.activity',
  profile: 'PageNames.profile'
};
export enum SOCIAL_LOGIN_PROVIDER {
  facebook = 'facebook',
  google = 'google'
}

export const ROWS_PER_PAGE_LIMIT = 7;
export const ITEMS_PER_PAGE_LIMIT = 16;

export enum WEBSHOP_DESIGN {
  banner_text = 'banner_text',
  banner = 'banner',
  text = 'text'
}

export enum SORT_TYPE {
  asc = 'asc',
  desc = 'desc'
}

export enum VISIBLE_STATUS {
  active = 'active',
  inactive = 'inactive'
}

export const DEFAULT_DEBOUNCE_DELAY = 500;

export const SHORT_INPUT_MAX_LENGTH = 255;
export const LONG_INPUT_MAX_LENGTH = 500;

export const ROLES_WITH_MOBILE_LAYOUT = [USER_ROLES.member];

export const MEMBER_LAYOUT_CONTENT_CONTAINER_ID = 'member-layout-container';
export const UNOSCORE_LINK = 'https://app.unoscore.no/';

export enum BENEFIT_STORE_TYPES {
  all_stores = 'all_stores',
  in_store = 'in_store',
  online = 'online'
}
export const WALKTHROUGH_STEPKEYS = {
  merchant: {
    fillProfile: 'fill_profile_merchant',
    createBenefit: 'create_benefit',
    addOrganisation: 'add_organisation',
    addBankingDetails: 'add_banking_details'
  },
  organisation: {
    fillProfile: 'fill_profile_organisation',
    addMerchant: 'add_merchant',
    inviteMembers: 'invite_members'
  },
  user: {
    linkCard: 'link_card'
  }
};

export const LOCAL_STORAGE_VALUES = {
  isRestricted: 'IS_RESTRICTED',
  restrictionReason: 'RESTRICTION_REASON',
  restrictionPopupClosed: 'RESTRICTION_POPUP_CLOSED',
  publicMerchantBannerClosed: 'PUBLIC_MERCH_BANNER_CLOSED',
  publicOrganisationBannerClosed: 'PUBLIC_ORG_BANNER_CLOSED',
  onboardingFeedPopupClosed: 'ONBOARDING_FEED_POPUP_CLOSED',
  onboardingBenefitSubscribePopupClosed:
    'ONBOARDING_BENEFIT_SUBSCRIBE_POPUP_CLOSED',
  onboardingBenefitOrganisationPopupClosed:
    'ONBOARDING_BENEFIT_ORGANISATION_POPUP_CLOSED',
  onboardingWebshopPopupClosed: 'ONBOARDING_WEBSHOP_POPUP_CLOSED',
  onboardingGeneralPopupClosed: 'ONBOARDING_GENERAL_MODAL_CLOSED',
  onboardingShown: 'ONBOARDING_SHOWN',
  onboardingOrganisation: {
    statesMemberTablePopupClosed: 'ONBOARDING_STATES_MEMBER_TABLE_POPUP_CLOSED',
    statesMerchantTablePopupClosed:
      'ONBOARDING_STATES_MERCHANT_TABLE_POPUP_CLOSED',
    justRedirectedFromMerchants: 'ONBOARDING_MERCH_JUST_REDIRECTED',
    merchantNotificationShown: 'ONBOARDING_MERCH_NOTIFICATION_SHOWN'
  },
  onboardingMerchant: {
    addedOrganisationPopupClosed:
      'ONBOARDING_MERCHANT_ADDED_ORGANISATION_POPUP_CLOSED',
    benefitCreatedPopupClosed: 'ONBOARDING_MERCHANT_ADDED_BENEFIT_POPUP_CLOSED'
  },
  workspaces: {
    current: 'WORKSPACE',
    all: 'WORKSPACES'
  },
  benefit: {
    newState: 'NEW_BENEFIT',
    creationStep: 'NEW_BENEFIT_STEP'
  }
};

export const SHOPPING_CATEGORY_ID = 3;

export enum CURRENCIES {
  nok = 'nok',
  sek = 'sek',
  dkk = 'dkk'
}

export const IBAN_REGEX = /^[A-Z]{2}[0-9]{2}[A-Z0-9]{11,30}$/;
